import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getFeepayments = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.feepayments_data.length <= 0 || data.date_from !== config.startDate || data.date_to !== config.endDate) {
    const response = await axios(configws)
    data = {  feepayments_data: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, status = null, sort, sortColumn } = config
  /* eslint-enable */
  const dataAsc = data.feepayments_data.sort((a, b) => {
    const aS = a[sortColumn] ?? ''
    const bS = b[sortColumn] ?? ''

    if (true) {
      return aS < bS ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(feepayments_data => {

      return (
        (
          String(feepayments_data.comision_id).toLowerCase().includes(queryLowered) ||
          (feepayments_data.date && feepayments_data.date.toLowerCase().includes(queryLowered)) ||
          (feepayments_data.bank && feepayments_data.bank.toLowerCase().includes(queryLowered)) ||
          (feepayments_data.id_closure && String(feepayments_data.id_closure).toLowerCase().includes(queryLowered)) ||
          (feepayments_data.amount && feepayments_data.amount.toLowerCase().includes(queryLowered)) ||
          (feepayments_data.exchange_rate && feepayments_data.exchange_rate.toLowerCase().includes(queryLowered)) ||
          (feepayments_data.payment_method && feepayments_data.payment_method.toLowerCase().includes(queryLowered)) ||
          (feepayments_data.internal_closure_id && feepayments_data.internal_closure_id.toLowerCase().includes(queryLowered)) ||
          (feepayments_data.currency && feepayments_data.currency.toLowerCase().includes(queryLowered))  ||
          (feepayments_data.invoice_or_receipt && feepayments_data.invoice_or_receipt.toLowerCase().includes(queryLowered))   
        ) 
        && 
        feepayments_data.feepayment_status === (status.length > 0 ? Number(status) : feepayments_data.feepayment_status)
      )
  })

  return [
    200,
    {
      allData: data.feepayments_data,
      total: filteredData.length,
      feepayments_data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return closure List for Comission
// ------------------------------------------------
let dataFeepayments = JSON.parse(localStorage.getItem("dataFeepayments")) || { feepayments_data: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/feepayments/list').reply(async config => {

  const user = getUserData()
  
  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      cluster_id = config.cluster_id
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
    }
      
    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country
    
    if (user.usercoc.role === 2) {
      user_id  = user.usercoc.user_id
    } else {
      user_id  = ""
    }
  }
  
  const body = {
    internal_closure_id:    "",
    cluster:                cluster_id,
    country:                country_id,
    office:                 office_id,
    user:                   user_id,
    date_from:              config.startDate,
    date_to:                config.endDate
  }

  if (localStorage.getItem("resetComision")) {
    if (localStorage.getItem("resetComision") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetComision")
  }

  const now = new Date()
  const diffInMinutes = (now - dataFeepayments.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataFeepayments = { feepayments_data: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getFeepayments(dataFeepayments, 1, GetApiCOC('getlistFeePayment'), user.token, body, config)

  dataFeepayments = { feepayments_data: result[1].allData, date_from: config.startDate, date_to: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  localStorage.setItem("dataFeepayments", JSON.stringify(dataFeepayments))

  return result
})

// ------------------------------------------------
// GET: Return ALL Feepayments for Excel Export
// ------------------------------------------------
mock.onGet('/apps/feepayments/export').reply(async config => {

  const user = getUserData()

  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      cluster_id = config.cluster_id
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
    }

    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country

    if (user.usercoc.role === 2) {
      user_id  = user.usercoc.user_id
    } else {
      user_id  = ""
    }
  }

  const body = {
    internal_closure_id:    "",
    cluster:                cluster_id,
    country:                country_id,
    office:                 office_id,
    user:                   user_id,
    date_from:              config.startDate,
    date_to:                config.endDate
  }

  const configws = {
    method: 'get',
    url:    GetApiCOC('getlistFeePaymentExport'),
    headers: {
      Accept:      'application/json',
      obrientoken: user.token
    },
    params: body
  }

  const response = await axios(configws)
  const allData  = base64ToString(response)

  const { q = '', status = null } = config
  const queryLowered = q.toLowerCase()

  const filteredData = allData.filter(row => {
    return (
      (
        String(row.comision_id).toLowerCase().includes(queryLowered) ||
        (row.deposit_bank && row.deposit_bank.toLowerCase().includes(queryLowered)) ||
        (row.id_closure && String(row.id_closure).toLowerCase().includes(queryLowered)) ||
        (row.closing_executive && row.closing_executive.toLowerCase().includes(queryLowered)) ||
        (row.invoice_or_receipt && row.invoice_or_receipt.toLowerCase().includes(queryLowered)) ||
        (row.commission_payment_method && row.commission_payment_method.toLowerCase().includes(queryLowered))
      )
      &&
      row.feepayment_status === (status && String(status).length > 0 ? Number(status) : row.feepayment_status)
    )
  })

  return [200, { feepayments_data: filteredData }]
})